import { OrderPriceNegotiationStatus } from "@/biz/order";
import i18n from "@/i18n";

// 此处顺序会影响某些地方 过滤条件显示的顺序 如：collaboration-influencer-第一个过滤框
export enum AdsOrderStatus {
  CollaborationEstablished = "Collaboration_established",
  PendingProductionKickoff = "Pending_production_kickoff", // 非寄样-待确认
  PendingCreatorAddress = "Pending_creator_address", // 待达人填写地址
  PendingProductShipment = "Pending_Product_shipment", // 待发货
  PendingProductArrival = "Pending_Product_Arrival", // 发货中
  UnderScriptProduction = "Under_script_production",
  UnderScriptReview = "Under_script_review",
  UnderContentProduction = "Under_content_production",
  UnderContentReview = "Under_content_review",
  AdsPendingPublish = "Ads_pending_publish",
  AdsPublished = "Ads_published",
  CollaborationCancelled = "Collaboration_cancelled",
  CollaborationWithdrawn = "Collaboration_withdrawn",
  Expired = "Expired", // 广告主15天无反馈，自动取消
  PendingCreatorAccountInfo = "Pending_creator_account_info", // 广告主通过，待达人填写账号信
  PendingAccountSetup = "Pending_account_setup", // 待广告主给达人设置账号
  // 下面两个状态是内部达人池匹配阶段
  PendingSelection = "Pending_selection",
  QuoteRequested = "Quote_requested",
}

export enum CancelReasonEnum {
  // Aha Pick 选择阶段未选中该达人。
  AHA_PICK_NOT_SELECTED = "AHA_PICK_NOT_SELECTED",
  // 广告主发起询价后，达人拒绝询价；此前未发送 opening offer。
  CREATOR_DECLINED_QUOTE_REQUEST = "CREATOR_DECLINED_QUOTE_REQUEST",
  // 广告主已发送 opening offer，达人拒绝该报价。
  CREATOR_DECLINED_OPENING_OFFER = "CREATOR_DECLINED_OPENING_OFFER",
  // 达人撤回申请或合作意向。
  CREATOR_WITHDREW = "CREATOR_WITHDREW",
  // 广告主在尚未进入议价前拒绝达人的首次报价。
  BRAND_DECLINED_QUOTE = "BRAND_DECLINED_QUOTE",
  // 广告主结束议价；广告主主动取消、Campaign 预算已满或达人数量已足够也归入该原因。
  BRAND_ENDED_NEGOTIATION = "BRAND_ENDED_NEGOTIATION",
  // 达人拒绝议价价格并结束协商。
  CREATOR_ENDED_NEGOTIATION = "CREATOR_ENDED_NEGOTIATION",
  // 达人交付逾期，或未按要求开始制作。
  MISSED_DEADLINE = "MISSED_DEADLINE",
  // 订单因不满足 Campaign 条件而取消。
  CAMPAIGN_REQUIREMENTS_NOT_MET = "CAMPAIGN_REQUIREMENTS_NOT_MET",
  // 订单由 AhaCreator 运营或客服取消。
  SUPPORT_CANCELLED = "SUPPORT_CANCELLED",
}

export const CancelReasonInfo: Record<CancelReasonEnum, { titleKey: string; commentKey: string }> = {
  [CancelReasonEnum.AHA_PICK_NOT_SELECTED]: {
    titleKey: "components.orderStatusComponent.cancelReasons.ahaPickNotSelected.title",
    commentKey: "components.orderStatusComponent.cancelReasons.ahaPickNotSelected.comment",
  },
  [CancelReasonEnum.CREATOR_DECLINED_QUOTE_REQUEST]: {
    titleKey: "components.orderStatusComponent.cancelReasons.creatorDeclinedQuoteRequest.title",
    commentKey: "components.orderStatusComponent.cancelReasons.creatorDeclinedQuoteRequest.comment",
  },
  [CancelReasonEnum.CREATOR_DECLINED_OPENING_OFFER]: {
    titleKey: "components.orderStatusComponent.cancelReasons.creatorDeclinedOpeningOffer.title",
    commentKey: "components.orderStatusComponent.cancelReasons.creatorDeclinedOpeningOffer.comment",
  },
  [CancelReasonEnum.CREATOR_WITHDREW]: {
    titleKey: "components.orderStatusComponent.cancelReasons.creatorWithdrew.title",
    commentKey: "components.orderStatusComponent.cancelReasons.creatorWithdrew.comment",
  },
  [CancelReasonEnum.BRAND_DECLINED_QUOTE]: {
    titleKey: "components.orderStatusComponent.cancelReasons.brandDeclinedQuote.title",
    commentKey: "components.orderStatusComponent.cancelReasons.brandDeclinedQuote.comment",
  },
  [CancelReasonEnum.BRAND_ENDED_NEGOTIATION]: {
    titleKey: "components.orderStatusComponent.cancelReasons.brandEndedNegotiation.title",
    commentKey: "components.orderStatusComponent.cancelReasons.brandEndedNegotiation.comment",
  },
  [CancelReasonEnum.CREATOR_ENDED_NEGOTIATION]: {
    titleKey: "components.orderStatusComponent.cancelReasons.creatorEndedNegotiation.title",
    commentKey: "components.orderStatusComponent.cancelReasons.creatorEndedNegotiation.comment",
  },
  [CancelReasonEnum.MISSED_DEADLINE]: {
    titleKey: "components.orderStatusComponent.cancelReasons.missedDeadline.title",
    commentKey: "components.orderStatusComponent.cancelReasons.missedDeadline.comment",
  },
  [CancelReasonEnum.CAMPAIGN_REQUIREMENTS_NOT_MET]: {
    titleKey: "components.orderStatusComponent.cancelReasons.campaignRequirementsNotMet.title",
    commentKey: "components.orderStatusComponent.cancelReasons.campaignRequirementsNotMet.comment",
  },
  [CancelReasonEnum.SUPPORT_CANCELLED]: {
    titleKey: "components.orderStatusComponent.cancelReasons.supportCancelled.title",
    commentKey: "components.orderStatusComponent.cancelReasons.supportCancelled.comment",
  },
};

export const getCancelReasonInfo = (cancelReason: CancelReasonEnum, t: any) => {
  const { titleKey, commentKey } = CancelReasonInfo[cancelReason];
  return {
    title: t(titleKey),
    comment: t(commentKey),
  };
};

// 订单状态：对应的 originalStatus 字段
export enum OrderStatus {
  // 万用状态
  Pending = 'Pending', // 待处理
  Created = 'Created', // 订单创建
  Invited = 'Invited', // 已发送邀约
  CreatorRejected = 'Creator_rejected', // 达人拒绝
  CreatorApplied = 'Creator_applied', // 达人同意
  ApplyRejected = 'Apply_rejected', // 平台拒绝
  PendingCreatorAddress = 'Pending_creator_address', // 广告主通过，待达人填写地址
  PendingProductShipment = 'Pending_Product_shipment', // 待发货
  PendingProductArrival = 'Pending_Product_Arrival', // 发货中
  PendingProductionKickoff = 'Pending_production_kickoff', // 广告主通过，待达人确认
  PendingCreatorAccountInfo = 'Pending_creator_account_info', // 广告主通过，待达人填写账号信息
  PendingAccountSetup = 'Pending_account_setup', // 待广告主给达人设置账号
  UnderProduction = 'Under_production', // 创作作品中
  UnderReview = 'Under_review',
  ReviewRejected = 'Review_rejected',
  PendingPublish = 'Pending_publish',
  PublishRejected = 'Publish_rejected',
  PendingPayment = 'Pending_payment',
  PaymentSubmitted = 'Payment_submitted',
  // 已经可以提款的状态
  /** @deprecated */
  PendingWithdraw = 'Pending_withdraw',
  Paid = 'Paid', // 全部提现完成后
  /** @deprecated */
  PaymentFailed = 'Payment_failed',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
}

export const getAdsOrderStatusLabel = (status: AdsOrderStatus, data: any, t: any) => {
  switch (status) {
    case AdsOrderStatus.PendingSelection:
      return t("components.orderStatusComponent.pendingSelection", { defaultValue: "Pending your selection" });
    case AdsOrderStatus.QuoteRequested:
      return !!data?.ahaPicksOffer
        ? t("components.orderStatusComponent.awaitingInfluencerReply", {
            defaultValue: "Awaiting influencer's reply",
          })
        : t("components.orderStatusComponent.quoteRequested", {
            defaultValue: "Awaiting influencer's quote",
          });
    case AdsOrderStatus.CollaborationEstablished:
      // 达人首次报价待广告主审核
      if (data?.priceNegotiationStatus === OrderPriceNegotiationStatus.UnderAdsFirstReview) {
        return t("components.orderStatusComponent.firstRateUnderAdvertiserReview", {
          defaultValue: "Influencer first rate under review",
        });
      }
      // 达人出价待广告主确认
      if (data?.priceNegotiationStatus === OrderPriceNegotiationStatus.UnderAdsReview) {
        return t("components.orderStatusComponent.counterOfferUnderAdvertiserReview", { defaultValue: "Influencer rate under review" });
      }
      // 广告主出价待达人确认
      if (data?.priceNegotiationStatus === OrderPriceNegotiationStatus.UnderCreatorReview) {
        return t("components.orderStatusComponent.priceProposalUnderInfluencerReview", { defaultValue: "Offer under influencer review" });
      }
      // 达人确认价格
      if (data?.priceNegotiationStatus === OrderPriceNegotiationStatus.PendingAdsApproval) {
        return t("components.orderStatusComponent.pendingPayment", { defaultValue: "Ready to pay" });
      }
      return t("components.orderStatusComponent.collaborationEstablished", { defaultValue: "New candidate" });
    case AdsOrderStatus.PendingProductionKickoff:
      return t("components.orderStatusComponent.pendingProductionKickoff", { defaultValue: "Pending production kickoff" });
    case AdsOrderStatus.PendingCreatorAddress:
      return t("components.orderStatusComponent.pendingCreatorAddress", { defaultValue: "Pending creator address" });
    case AdsOrderStatus.UnderScriptProduction:
      return t("components.orderStatusComponent.underScriptProduction", { defaultValue: "Under script production" });
    case AdsOrderStatus.UnderScriptReview:
      return t("components.orderStatusComponent.underScriptReview", { defaultValue: "Under script review" });
    case AdsOrderStatus.UnderContentProduction:
      return t("components.orderStatusComponent.underContentProduction", { defaultValue: "Under content production" });
    case AdsOrderStatus.UnderContentReview:
      return t("components.orderStatusComponent.underContentReview", { defaultValue: "Under content review" });
    case AdsOrderStatus.AdsPendingPublish:
      return t("components.orderStatusComponent.adsPendingPublish", { defaultValue: "Ads pending publish" });
    case AdsOrderStatus.AdsPublished:
      return t("components.orderStatusComponent.adsPublished", { defaultValue: "Ads published" });
    case AdsOrderStatus.CollaborationCancelled: {
      const cancelReason = data?.cancelReason as CancelReasonEnum | undefined;
      return cancelReason && CancelReasonInfo[cancelReason]
        ? getCancelReasonInfo(cancelReason, t).title
        : t("components.orderStatusComponent.collaborationCancelled", { defaultValue: "Collaboration cancelled" });
    }
    case AdsOrderStatus.PendingProductShipment:
      return t("components.orderStatusComponent.pendingProductShipment", { defaultValue: "Pending product shipment" });
    case AdsOrderStatus.PendingProductArrival:
      return t("components.orderStatusComponent.pendingProductArrival", { defaultValue: "Pending product arrival" });
    case AdsOrderStatus.CollaborationWithdrawn: {
      const cancelReason = data?.cancelReason as CancelReasonEnum | undefined;
      return cancelReason && CancelReasonInfo[cancelReason]
        ? getCancelReasonInfo(cancelReason, t).title
        : t("components.orderStatusComponent.collaborationWithdrawn", { defaultValue: "Collaboration withdrawn" });
    }
    case AdsOrderStatus.Expired:
      return t("components.orderStatusComponent.expired", { defaultValue: "Expired" });
    case AdsOrderStatus.PendingCreatorAccountInfo:
      return t("components.orderStatusComponent.pendingCreatorAccountInfo", {
        defaultValue: "Awaiting influencer access information",
      });
    case AdsOrderStatus.PendingAccountSetup:
      return t("components.orderStatusComponent.pendingAccountSetup", {
        defaultValue: "Pending brand setup",
      });
    default:
      return String(status);
  }
};

export enum AdsPlatform {
  Youtube = "youtube",
  TikTok = "tiktok",
  Instagram = "instagram",
  Facebook = "facebook",
  LinkedIn = "linkedin",
  X = "x",
  Twitter = "twitter",
}

export enum leadsStatus {
  Created = "Created",
  Paid = "Paid",
  Converted = "Converted",
  Forwarded = "Forwarded",
}

// 延期申请状态 PostponeStatus
export enum PostponeStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
}

// 订单取消类型
export enum OrderCancelType {
  // 广告主能看到的
  /** 广告主拒绝申请 */
  ApplyRejected = "Apply_rejected",
  /** 内容被拒绝 */
  DraftRejected = "Draft_rejected",
  /** 广告主充值失败 */
  ChargeFailed = "Charge_failed",
  /** 达人逾期 */
  CreatorOverdue = "Overdue",
  /** 达人未开始制作 */
  CreatorNotStart = "Creator_not_start",
  /** 达人撤回申请 */
  CreatorWithdraw = "Creator_withdraw",
  /** 申请过期 */
  ApplyExpired = "Apply_expired",
  /** 寄样地区不符合 */
  InvalidShipmentLocation = "Invalid_shipment_location",

  // 广告主看不到的
  /** 达人拒绝 */
  CreatorRejected = "Creator_rejected",
  /** 申请已满 */
  NoQuota = "No_quota",
  /** Cpm超过限制 */
  CpmLimit = "Cpm_limit",
  /** 受众校验不通过或造假 */
  ValidateCancelled = "Validate_cancelled",
  /** 运营取消 */
  OpsCancelled = "Ops_cancelled",
  /** 其他 */
  Others = "Others",
}


// linkedin 的两种类型   达人端有相同的枚举 要改一块改
export enum LinkedInContentType {
  POST = 'Post', // 一开始用的类型，后来细分成下面的类型，用来兼容老数据
  IMAGE_TEXT = 'Image & Text',
  VIDEO = 'Video'
}
// linkedin 的两种类型对应的标签  达人端有相同的枚举 要改一块改
export const LinkedInContentTypeLabel = {
  [LinkedInContentType.POST]: 'LinkedIn post', // 兼容旧数据
  [LinkedInContentType.IMAGE_TEXT]: 'LinkedIn image posts',
  [LinkedInContentType.VIDEO]: 'LinkedIn video posts'
};

// 寄件物流状态
export enum DeliveryStatusMap {
  /** 快递员已收到包裹信息，正要取件。 */
  INFO_RECEIVED = 'InfoReceived',
  /** 包裹在运输途中。 */
  TRANSIT = 'Transit',
  /** 包裹已到达当地地点或正在前往您家的途中。 */
  OUT_FOR_DELIVERY = 'Out for Delivery',
  /** 已尝试递送包裹，但由于某些原因而失败。通常，快递员会很快安排另一次送货。 */
  UNDELIVERED = 'Undelivered',
  /** 包裹已签收！ */
  DELIVERED = 'Delivered',
  /** 包裹暂时查询不到信息。 */
  NOT_FOUND = 'Not Found',
  /** 包裹可能已退回给发件人、损坏、丢失或其他异常。 */
  EXCEPTION = 'Exception',
  /** 包裹最后一条轨迹距今30天未更新。发生这种情况时，请联系快递员查询更多详细信息。 */
  EXPIRED = 'Expired',
  /** 新增包裹正在查询中，请等待。 */
  PENDING = 'Pending',
};

export const deliveryStatusMap = {
  [DeliveryStatusMap.INFO_RECEIVED]: i18n.t('orderDetail.deliveryStatus.infoReceived'),
  [DeliveryStatusMap.TRANSIT]: i18n.t('orderDetail.deliveryStatus.transit'),
  [DeliveryStatusMap.OUT_FOR_DELIVERY]: i18n.t('orderDetail.deliveryStatus.outForDelivery'),
  [DeliveryStatusMap.UNDELIVERED]: i18n.t('orderDetail.deliveryStatus.undelivered'),
  [DeliveryStatusMap.DELIVERED]: i18n.t('orderDetail.deliveryStatus.delivered'),
  [DeliveryStatusMap.NOT_FOUND]: i18n.t('orderDetail.deliveryStatus.notFound'),
  [DeliveryStatusMap.EXCEPTION]: i18n.t('orderDetail.deliveryStatus.exception'),
  [DeliveryStatusMap.EXPIRED]: i18n.t('orderDetail.deliveryStatus.expired'),
  [DeliveryStatusMap.PENDING]: i18n.t('orderDetail.deliveryStatus.pending'),
};

// 每种类型订单对应的描述   达人端有相同的枚举 要改一块改
export const getPlatformVideoContentType = ({
  platform,
  contentType
}: {
  platform: string;
  contentType?: string;
}) => {
  if (contentType === 'Dedicated video' || contentType === 'Integrated video') {
    return contentType;
  }
  if (
    contentType === 'Post' &&
    AdsPlatform.Instagram.toLowerCase() === platform
  ) {
    return 'Carousel post';
  }
  if (AdsPlatform.Youtube.toLowerCase() === platform)
    return 'Dedicated video';
  if (AdsPlatform.TikTok.toLowerCase() === platform) return 'Tiktok video';
  if (AdsPlatform.Instagram.toLowerCase() === platform) return 'Reels';
  if (AdsPlatform.Twitter.toLowerCase() === platform) return 'Post';
  if (AdsPlatform.LinkedIn.toLowerCase() === platform) {
    return (
      LinkedInContentTypeLabel[contentType as LinkedInContentType] || 'Post'
    );
  }
  return contentType || 'Post';
};

// 达人端有相同的 要改一块改
export const getPlatformVideoContentTypeDesc = (
  key: string,
  platform?: string
) => {
  const map: any = {
    'Dedicated video': i18n.t('orderDetail.orderTypeDescription.dedicatedVideo', {
      defaultValue:
        'A standalone YouTube video created specifically to focus entirely on promoting the brand'
    }),
    'Integrated video': i18n.t('orderDetail.orderTypeDescription.integratedVideo', {
      defaultValue:
        'A YouTube video that seamlessly incorporates brand promotion within your regular content'
    }),
    Reels: i18n.t('orderDetail.orderTypeDescription.reels', {
      defaultValue:
        'A short Instagram video created to exclusively promote a brand'
    }),
    'Carousel post': i18n.t('orderDetail.orderTypeDescription.carouselPost', {
      defaultValue:
        'A single Instagram post featuring multiple brand photos or videos that users can swipe through'
    }),
    'Tiktok video': i18n.t('orderDetail.orderTypeDescription.tiktokVideo', {
      defaultValue:
        'Exclusive TikTok video custom-made specifically for the brand.'
    }),
    [LinkedInContentTypeLabel[LinkedInContentType.VIDEO]]: i18n.t(
      'orderDetail.orderTypeDescription.linkedinVideoPost',
      {
        defaultValue:
          'A professional video post where you speak about or demonstrate the brand — such as use cases, expert opinions, or testimonials.'
      }
    ),
    [LinkedInContentTypeLabel[LinkedInContentType.IMAGE_TEXT]]: i18n.t(
      'orderDetail.orderTypeDescription.linkedinImagePost',
      {
        defaultValue:
          'A carousel post featuring branded visuals, infographics, or professional photos'
      }
    )
  };
  if (key === 'Post' && platform === AdsPlatform.Twitter.toLowerCase()) {
    return i18n.t('orderDetail.orderTypeDescription.twitterPost', {
      defaultValue: 'Exclusive X post custom-made specifically for the brand.'
    });
  }
  return map?.[key] || '';
};
